import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { MobilemenuCollectionCatagoryMappingEditSchema } from '../MobilemenuCollectionCatagoryMappingSchema';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';

export function MobilemenuCollectionCatagoryMappingAddEdit(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Add Mobile Menu");
    const [buttonText, setButtonText] = useState("Add");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [product, setMobileMenu] = useState();
    const [collectionCatagory, setCollectionCatagory] = useState();
    const [menuVerificationTypes, setMenuVerificationTypes] = useState();
    const [mobilemenuCollectionCatagoryMapping, setMobilemenuCollectionCatagoryMapping] = useState({
        groupID: '0',
        operationEntityID: '0',
        mobileMenuID: '0',
        collectionCategoryID: '0',
        primaryMenuVerificationTypeID: '0',
        secondaryMenuVerificationTypeID: '0',
        collectionTagEnabled: true,
        isActive: true,
        digitalScaleEnabled: true
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "completed successfuly."
    });

    const schema = Joi.object(MobilemenuCollectionCatagoryMappingEditSchema).options({ allowUnknown: true });

    useEffect(() => {
        if (data && edit) {
            setTitle("Edit Mobile Menu to Collection Category");
            fillOperationEntityMobileMenuEditdata();
            setButtonText('Edit');
        } else {
            setTitle("Add Mobile Menu to Collection Category");
        }
    }, [])

    useEffect(() => {
        trackPromise(
            getGroupsForDropdown()
        )
        trackPromise(
            getMenuVerificationTypes()
            )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [mobilemenuCollectionCatagoryMapping.groupID]);

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropdown()
        )
    }, [mobilemenuCollectionCatagoryMapping.operationEntityID]);

useEffect(() => {
    trackPromise(
        getMobileMenuForDropDown()
    )
    }, [mobilemenuCollectionCatagoryMapping.collectionCategoryID]);

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getAllOperationEntitiesForDropDown(mobilemenuCollectionCatagoryMapping.groupID);
        setOperationEntity(opEntities);
    }

    async function getCollectionCategoryForDropdown() {
        const collectionCatagories = await services.getCollectionCategoryByOperationentity(mobilemenuCollectionCatagoryMapping.operationEntityID);
        setCollectionCatagory(collectionCatagories);
    }

    async function getMobileMenuForDropDown() {
        var mobileMenu = [];
        if (edit && data) { 
            mobileMenu = await services.getUsedMobileMenus(data.collectionCategoryID);
        } else {
            mobileMenu = await services.getAvialableMobileMenus(mobilemenuCollectionCatagoryMapping.collectionCategoryID);
        }
        setMobileMenu(mobileMenu);
    }

    async function getMenuVerificationTypes() {
        var menuverificationTypes = await services.getAllMenuVerificationTypes();
        setMenuVerificationTypes(menuverificationTypes);
    }

    async function fillOperationEntityMobileMenuEditdata() {
        const selectedOperationEntity = await services.getGroupByCollectionCatagoryID(data.collectionCategoryID.toString());

        if (selectedOperationEntity) {
            setMobilemenuCollectionCatagoryMapping({
                ...mobilemenuCollectionCatagoryMapping,
                groupID: selectedOperationEntity[0].groupID,
                operationEntityID: selectedOperationEntity[0].operationEntityID,
                mobileMenuID: data.mobileMenuID,
                collectionCategoryID: data.collectionCategoryID,
                primaryMenuVerificationTypeID: data.primaryMenuVerificationTypeID,
                secondaryMenuVerificationTypeID: data.secondaryMenuVerificationTypeID,
                collectionTagEnabled: data.collectionTagEnabled,
                isActive: data.isActive,
                digitalScaleEnabled: data.digitalScaleEnabled
            });
        }
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.name === 'isActive' ? target.checked : target.value

        if (target.name === "collectionCategoryCode") {
            if (target.value.length === 3) return false
        }

        const error = { ...errors };
        const errorMessage = validateProperty(target, MobilemenuCollectionCatagoryMappingEditSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setMobilemenuCollectionCatagoryMapping({
            ...mobilemenuCollectionCatagoryMapping,
            [e.target.name]: value
        });
        setErrors(error);
    }

    function handleCollectionTagEnabled(e){
        setMobilemenuCollectionCatagoryMapping({
            ...mobilemenuCollectionCatagoryMapping,
            collectionTagEnabled: e.target.checked
        });
    }

    function handleIsActive(e){
        setMobilemenuCollectionCatagoryMapping({
            ...mobilemenuCollectionCatagoryMapping,
            isActive: e.target.checked
        });
    }

    function handleDigitalScaleEnabled(e){
        setMobilemenuCollectionCatagoryMapping({
            ...mobilemenuCollectionCatagoryMapping,
            digitalScaleEnabled: e.target.checked
        });
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, mobilemenuCollectionCatagoryMapping);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        if (!edit) {
            var result = await services.AddMobilemenuCollectionCatagory(mobilemenuCollectionCatagoryMapping);
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
            afterSuccessfulyChanged(result.statusCode);
        } else if (edit) {
            var result = await services.EditMapping(mobilemenuCollectionCatagoryMapping, data.collectionCategoryMenuID);
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
            afterSuccessfulyChanged(result.statusCode);
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/mobilemenucollectioncategorytypemapping' })
            }, 1500);
        }
    }

    function clearState() {
        setMobilemenuCollectionCatagoryMapping({
            ...mobilemenuCollectionCatagoryMapping,
            groupID: '0',
            operationEntityID: '0',
            mobileMenuID: '0',
            collectionCategoryID: '0',
            primaryMenuVerificationTypeID: '0',
            secondaryMenuVerificationTypeID: '0',
            collectionTagEnabled: true,
            isActive: true,
            digitalScaleEnabled: true
        });
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    path="/mobilemenucollectioncategorytypemapping"
                                    buttonText="Back to listing"
                                />
                            </div>
                            <hr />
                            <form onSubmit={(e) => handleSave(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={(edit && data) ? true : false}
                                            value={mobilemenuCollectionCatagoryMapping.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={(edit && data) ? true : false}
                                            value={mobilemenuCollectionCatagoryMapping.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionCategoryID">Collection Category *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionCategoryID"
                                            id="collectionCategoryID"
                                            name="collectionCategoryID"
                                            disabled={(edit && data) ? true : false}
                                            value={mobilemenuCollectionCatagoryMapping.collectionCategoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection Category--</MenuItem>
                                            {generateDropDownMenu(collectionCatagory)}
                                        </Select>
                                        {errors["collectionCategoryID"] && <FormHelperText error>{errors["collectionCategoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="mobileMenuID">Mobile Menu *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="mobileMenuID"
                                            id="mobileMenuID"
                                            name="mobileMenuID"
                                            disabled={(edit && data) ? true : false}
                                            value={mobilemenuCollectionCatagoryMapping.mobileMenuID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Mobile Menu--</MenuItem>
                                            {generateDropDownMenu(product)}
                                        </Select>
                                        {errors["mobileMenuID"] && <FormHelperText error>{errors["mobileMenuID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="primaryMenuVerificationTypeID">Primary Menu Verification *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="primaryMenuVerificationTypeID"
                                            id="primaryMenuVerificationTypeID"
                                            name="primaryMenuVerificationTypeID"
                                            disabled={(edit && data) ? true : false}
                                            value={mobilemenuCollectionCatagoryMapping.primaryMenuVerificationTypeID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Primary Menu Verification--</MenuItem>
                                            {generateDropDownMenu(menuVerificationTypes)}
                                        </Select>
                                        {errors["primaryMenuVerificationTypeID"] && <FormHelperText error>{errors["primaryMenuVerificationTypeID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="secondaryMenuVerificationTypeID">Secondary Menu Verification Type *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="secondaryMenuVerificationTypeID"
                                            id="secondaryMenuVerificationTypeID"
                                            name="secondaryMenuVerificationTypeID"
                                            disabled={(edit && data) ? true : false}
                                            value={mobilemenuCollectionCatagoryMapping.secondaryMenuVerificationTypeID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Secondary Menu Verification--</MenuItem>
                                            {generateDropDownMenu(menuVerificationTypes)}
                                        </Select>
                                        {errors["secondaryMenuVerificationTypeID"] && <FormHelperText error>{errors["secondaryMenuVerificationTypeID"]}</FormHelperText>}
                                    </div>
                                </div>

                                {/* {(edit && data) ? null : */}
                                    <div>
                                        <label>Active</label>
                                        <div className="form-group row">
                                            <div className="col-md ">
                                                <input
                                                    id="isActive"
                                                    switch="none"
                                                    className="mr-2"
                                                    type="checkbox"
                                                    name="isActive"
                                                    onChange={(e) => handleIsActive(e)}
                                                    checked={mobilemenuCollectionCatagoryMapping.isActive}
                                                />
                                                <label htmlFor="isActive" data-on-label="Yes"
                                                    data-off-label="No"></label>
                                            </div>
                                        </div>
                                        <label>Collection Tag Enabled</label>
                                        <div className="form-group row">
                                            <div className="col-md ">
                                                <input
                                                    id="collectionTagEnabled"
                                                    switch="none"
                                                    className="mr-2"
                                                    type="checkbox"
                                                    name="collectionTagEnabled"
                                                    onChange={(e) => handleCollectionTagEnabled(e)}
                                                    checked={mobilemenuCollectionCatagoryMapping.collectionTagEnabled}
                                                />
                                                <label htmlFor="collectionTagEnabled" data-on-label="Yes"
                                                    data-off-label="No"></label>
                                            </div>
                                        </div>
                                        <label>Digital Scale Enabled</label>
                                        <div className="form-group row">
                                            <div className="col-md ">
                                                <input
                                                    id="digitalScaleEnabled"
                                                    switch="none"
                                                    className="mr-2"
                                                    type="checkbox"
                                                    name="digitalScaleEnabled"
                                                    onChange={(e) => handleDigitalScaleEnabled(e)}
                                                    checked={mobilemenuCollectionCatagoryMapping.digitalScaleEnabled}
                                                />
                                                <label htmlFor="digitalScaleEnabled" data-on-label="Yes"
                                                    data-off-label="No"></label>
                                            </div>
                                        </div>
                                    </div>
                                    {/* } */}

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, mobilemenuCollectionCatagoryMapping)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonText}
                                    />
                                    {(edit && data) ? null :
                                        <input
                                            type="button"
                                            className="btn btn-warning pull-right"
                                            value="Clear"
                                            onClick={onCancelClick}
                                        />}
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}